import { render, staticRenderFns } from "./template.vue?vue&type=template&id=076dcb43&scoped=true"
import script from "./template.vue?vue&type=script&lang=ts"
export * from "./template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076dcb43",
  null
  
)

export default component.exports